var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", { attrs: { id: "bibModal", "hide-footer": true } }, [
    _c(
      "div",
      { attrs: { id: "bibForm" } },
      [
        _c(
          "div",
          { staticClass: "formTitle" },
          [
            _c("svg-image", { attrs: { image: "iconBib" } }),
            _c("h5", [_vm._v(_vm._s(_vm.$t("bib.modal.head")))]),
            _c("h6", [_vm._v(_vm._s(_vm.$t("bib.modal.date")))])
          ],
          1
        ),
        _c("b-row", {
          domProps: { innerHTML: _vm._s(_vm.$t("bib.modal.step")) }
        }),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("bib.modal.ltnc")))])
        ]),
        _c("div", {
          staticClass: "termsConditions",
          domProps: { innerHTML: _vm._s(_vm.$t("bib.modal.tnc")) }
        }),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("bib.modal.lform")))])
        ]),
        _c(
          "b-form",
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("bib.modal.fname"),
                  "label-for": "",
                  description: _vm.$t("bib.modal.fnamedesc")
                }
              },
              [
                _c("b-form-input", {
                  attrs: { id: "name", required: "", placeholder: "" }
                })
              ],
              1
            ),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("bib.modal.femail"),
                  "label-for": "",
                  description: _vm.$t("bib.modal.femaildesc")
                }
              },
              [
                _c("b-form-input", {
                  attrs: { id: "email", type: "email", required: "" }
                })
              ],
              1
            ),
            _c(
              "b-form-checkbox",
              {
                attrs: {
                  id: "acceptance",
                  name: "acceptance",
                  value: "accepted",
                  "unchecked-value": "not_accepted"
                }
              },
              [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("bib.modal.facceptance"))
                  }
                })
              ]
            ),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      block: "",
                      type: "submit",
                      variant: "primary",
                      size: "lg"
                    }
                  },
                  [
                    _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                    _vm._v(" " + _vm._s(_vm.$t("bib.modal.btn")))
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BibModal.vue?vue&type=template&id=aef9ecbc&
// module id = 878
// module chunks = 0